import { Role } from '@/utils/auth';
import log, { LOG_TYPE } from '@/utils/log';

const initialState = () => ({
  expanded: false,
});

const html = document.documentElement;

// TODO: Temporary hidden communities
// const communities = [
//   {
//     name: 'Food',
//     icon: require('@/assets/icons/optimized/communities/berry_white.svg'),
//     to: { name: 'FoodCommunityPage' },
//   },
//   {
//     name: 'Wellness',
//     icon: require('@/assets/icons/optimized/communities/heart_white.svg'),
//     to: { name: 'WellnessCommunityPage' },
//   },
//   {
//     name: 'Music',
//     icon: require('@/assets/icons/optimized/communities/music.svg'),
//     to: { name: 'MusicCommunityPage' },
//   },
//   {
//     name: 'Writers',
//     icon: require('@/assets/icons/optimized/communities/writers.svg'),
//     to: { name: 'WritersCommunityPage' },
//   },
//   {
//     name: 'Visual Artists',
//     icon: require('@/assets/icons/optimized/communities/visualArtists.svg'),
//     to: { name: 'VisualArtistCommunityPage' },
//   },
//   {
//     name: 'Entrepreneurs & Professionals',
//     icon: require('@/assets/icons/optimized/communities/entrepreneurs.svg'),
//     to: { name: 'EntrepreneursCommunityPage' },
//   },
//   {
//     name: 'Coaches & Consultants',
//     icon: require('@/assets/icons/optimized/communities/coaches.svg'),
//     to: { name: 'CoachesCommunityPage' },
//   },
//   {
//     name: 'Businesses & Brands',
//     icon: require('@/assets/icons/optimized/communities/businesses.svg'),
//     to: { name: 'BusinessesCommunityPage' },
//   },
// ];

const genericMenu = [
  {
    name: 'Pricing',
    to: { name: 'Pricing' },
  },
  // TODO: maybe need to remove or change later
  // {
  //   name: 'Communities',
  //   menu: communities,
  // },
  {
    name: 'Blog',
    to: {
      name: 'Profile',
      params: {
        username: 'creatorresources',
      },
    },
  },
];

const guestMenu = genericMenu.concat([
  {
    name: 'Sign in',
    to: { name: 'SignIn' },
  },
  {
    name: 'Sign up',
    to: { name: 'SignUp' },
    highlighted: true,
    accent: true,
    signup: true,
  },
]);

const supporterMenu = genericMenu.concat([
  {
    name: 'My account',
    to: { name: 'Dashboard' },
    dashboard: true,
    highlighted: true,
  },
]);

const creatorMenu = genericMenu.concat([
  {
    name: 'My Dashboard',
    to: { name: 'Dashboard' },
    highlighted: true,
    accent: true,
    dashboard: true,
  },
]);

const adminMenu = creatorMenu.concat([
  {
    name: 'Admin',
    to: { name: 'Admin' },
    accent: true,
  },
]);

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    expand(state) {
      state.expanded = true;
      html.classList.add('popup');
    },
    collapse(state) {
      state.expanded = false;
      html.classList.remove('popup');
    },
  },
  getters: {
    expanded: state => state.expanded,
    menu: (state, getters, rootState, rootGetters) => {
      const user = rootGetters['user/user'];
      const { role = Role.GUEST } = user || {};
      let menu;

      switch (role) {
        case Role.GUEST:
          menu = guestMenu;
          break;
        case Role.CREATOR:
          menu = creatorMenu;
          break;
        case Role.SUPPORTER:
          menu = supporterMenu;
          break;
        case Role.ADMIN:
          menu = adminMenu;
          break;
        default:
          log(`Role '${role}' is not defined to get the menu`, LOG_TYPE.ERROR);
          menu = guestMenu;
      }

      menu.forEach((item) => {
        if (item.dashboard) {
          Object.assign(item, {
            image: user.avatarUrl,
            defaultImage: !user.avatarUrl,
          });
        }
      });

      return menu;
    },
  },
};
